import { useCallback, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { Button, Icon } from '@kolking/react-ui';

import { FormInput, type FormInputProps } from './FormInput';
import { LocationDialog } from '../LocationDialog';

export const FormLocation = (props: FormInputProps) => {
  const { getFieldProps, setFieldValue } = useFormikContext();
  const { name } = props;

  const value = useMemo(() => {
    const value = getFieldProps<string>(name).value;

    if (value) {
      const coordinates = value.split(',');
      const lat = parseFloat(coordinates[0]);
      const lng = parseFloat(coordinates[1]);

      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        return { lat, lng } as google.maps.LatLngLiteral;
      }
    }
  }, [name, getFieldProps]);

  const handleConfirm = useCallback(
    (value?: google.maps.LatLngLiteral) => {
      if (value) {
        const lat = value.lat.toFixed(6);
        const lng = value.lng.toFixed(6);

        void setFieldValue(name, `${lat},${lng}`);
      }
    },
    [name, setFieldValue],
  );

  return (
    <LocationDialog onConfirm={handleConfirm}>
      {(dialog) => (
        <FormInput {...props} readOnly onClick={() => dialog.show({ value })}>
          <Button
            type="button"
            variant="tertiary"
            icon={<Icon name="location" scheme="neutral" />}
            onClick={() => dialog.show({ value })}
          />
        </FormInput>
      )}
    </LocationDialog>
  );
};
